export const linkResolver = (doc) => {
  switch (doc.type) {
    case "page":
      if (doc.uid === "__home__") return "/";
      return `/${doc.uid}`;
    case "case":
      return `/arbeiten/${doc.uid}`;
    case "employee":
      return `/agentur/${doc.uid}`;
  }
  return "/";
}
